import { INSERT, SELECT, UPDATE } from "@/utils/database_module"
import { Question } from "@/utils/types"

type QuestionData = Omit<Question, "id" | "date" | "modified_date" | "send_notif"   >;

const chatBotQuestions = {
    getAll : async () => {
        const chatBotQuestions  = await SELECT(" chatbot_questions " , { conditions : [{column : "is_deleted" , operator : "=" , value : 0}] , order : "date ASC"}) as (Question & { name: { ar?: string; fr?: string; en: string; } })[];
        for (const question of chatBotQuestions) {
            question.next_questions= JSON.parse(`${question.next_questions}`)
            question.question= JSON.parse(`${question.question}`)
            question.response= JSON.parse(`${question.response}`)
            question.name=  question.question
        }
        return chatBotQuestions 
    },

    insert : async (chatBotQuestions  : QuestionData) => {
        return await INSERT("chatbot_questions " , chatBotQuestions )
    },

    update : async (id : number , chatBotQuestions  : QuestionData) => {
        return await UPDATE("chatbot_questions " , chatBotQuestions  , [{column : "id" , operator : "=" , value : id}])
     
    },

    delete : async (id : number) => {
        return await UPDATE("chatbot_questions " , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
    },

}

export default chatBotQuestions;